import React from "react";
import { IoMdSearch, IoMdMore } from "react-icons/io";

import { NextImage } from "../NextImage";
import { PreviewLayout } from ".";
import { QRProps } from "@/contexts/QREditorContext/types";

export default function PreviewWhatsapp(props: QRProps<"whatsapp">) {
  const {
    data: { message = "" },
  } = props;
  const isInitPreview = props?.initPreview;

  const inlineStylesBackgroundImage = {
    backgroundImage: `url(/images/phone-previews/defaultPreview/whatsapp-wallpaper.png)`,
    backgroundSize: "contain",
    backgroundPosition: "center",
  };

  return (
    <PreviewLayout
      page="whatsapp"
      dataQA="preview-whatsapp-container"
      isInitPreview={isInitPreview}
      containerStyle={inlineStylesBackgroundImage}>
      <div className="preview-whatsapp__header">
        <div className="preview-whatsapp__header-title">Whatsapp</div>
        <div className="preview-whatsapp__header-icons">
          <IoMdSearch />
          <IoMdMore />
        </div>
      </div>
      <div className="preview-whatsapp__chat">
        <div className="preview-whatsapp__chat--message">
          <NextImage
            src={"/images/phone-previews/defaultPreview/emoji.png"}
            width={24}
            height={24}
            alt={"emoji smiley face"}
          />
          <p className="whatsapp-message">{message}</p>
          <NextImage
            src={"/images/phone-previews/defaultPreview/attach.png"}
            width={24}
            height={24}
            alt={"emoji attach file"}
          />
        </div>
        <NextImage
          src={"/images/phone-previews/defaultPreview/send.png"}
          width={40}
          height={40}
          alt={"send icon"}
          className="preview-whatsapp__chat--send"
        />
      </div>
    </PreviewLayout>
  );
}
